/**
 * Operator API Service
 * @description Backend 운영자 관리 API 연동
 */

import { apiClient } from '@/utils/httpClient';

export interface Operator {
  id: string;
  username: string;
  createdAt: string | null;
  updatedAt: string | null;
  permissions?: string[];
  tenantIds?: string[] | null;
}

export interface CreateOperatorRequest {
  username: string;
  password: string;
  permissions?: string[];
  tenantIds?: string[] | null;
}

export interface UpdateOperatorRequest {
  username?: string;
  password?: string;
  permissions?: string[];
  tenantIds?: string[] | null;
}

/**
 * 운영자 목록 조회
 */
export async function getOperators(): Promise<Operator[]> {
  return apiClient.get<Operator[]>('/admin/operators');
}

/**
 * 운영자 생성
 */
export async function createOperator(data: CreateOperatorRequest): Promise<Operator> {
  return apiClient.post<Operator>('/admin/operators', data);
}

/**
 * 운영자 수정
 */
export async function updateOperator(id: string, data: UpdateOperatorRequest): Promise<Operator> {
  return apiClient.put<Operator>(`/admin/operators/${id}`, data);
}

/**
 * 운영자 삭제
 */
export async function deleteOperator(id: string): Promise<{ success: boolean }> {
  return apiClient.delete<{ success: boolean }>(`/admin/operators/${id}`);
}
